/* eslint-disable camelcase */
import { pending, fulfilled, loadStatus } from 'lib/promiseMiddlewareHelpers'
import fetchJSON from 'lib/fetchJSON'
import Immutable, { Map, Record } from 'immutable'

// Actions
export const SET_PREFERENCE = 'currentUser/SET_PREFERENCE'
export const CLEAR_TRIAL_BANNER = 'currentUser/CLEAR_TRIAL_BANNER'
export const LOAD_FRIENDS = 'currentUser/LOAD_FRIENDS'
export const NEWSLETTER_SUBSCRIBE = 'currentUser/NEWSLETTER_SUBSCRIBE'
export const LOAD_CLUBS = 'currentUser/LOAD_CLUBS'

const {
  id,
  name,
  email,
  account_level,
  email_notifications,
  email_on_update,
  notifications_serialized,
  highlighted_photo_id,
  locality,
  administrative_area,
  country_code,
  preferences,
  profile_image_color,
  description,
  in_active_trial,
  trial_end_date,
  trial_show_banner,
  weeks_start_on,
  created_at,
  hr_max,
  metric_units,
  visibility
} = (window.rwgps && window.rwgps.config.currentUser) || {}

const currentUserFromPreload = {
  id,
  name,
  email,
  locality,
  description,
  createdAt: created_at,
  highlightedPhotoId: highlighted_photo_id,
  adminArea: administrative_area,
  countryCode: country_code,
  notifications: notifications_serialized, // TODO this should probably be its own reducer
  accountLevel: account_level,
  preferences: Map(preferences),
  friends: Record({ loadStatus: null, records: Map() })(),
  clubs: Record({ loadStatus: null, records: Map() })(),
  emailNotifications: email_notifications,
  emailOnUpdate: email_on_update,
  profileImageColor: profile_image_color || '#32309B',
  inActiveTrial: in_active_trial,
  trialEndDate: trial_end_date,
  trialShowBanner: trial_show_banner,
  weeksStartOn: weeks_start_on,
  maxHR: hr_max,
  metricUnits: metric_units,
  visibility
}

export const reducer = (state = currentUserFromPreload, action) => {
  switch (action.type) {
    case SET_PREFERENCE:
    case pending(SET_PREFERENCE):
      const { key, value } = action.meta
      return { ...state, preferences: state.preferences.set(key, value) }
    case fulfilled(LOAD_FRIENDS): {
      const { payload } = action
      const map = Map(payload.friends.map(f => [f.id, Immutable.fromJS(f)]))
      const records = state.friends.records.merge(map)
      return { ...state, friends: state.friends.merge({ records, loadStatus: loadStatus.fulfilled }) }
    }
    case fulfilled(LOAD_CLUBS): {
      const { payload } = action
      const map = Map(payload.results.map(c => [c.id, Immutable.fromJS(c)]))
      const records = state.clubs.records.merge(map)
      return { ...state, clubs: state.clubs.merge({ records, loadStatus: loadStatus.fulfilled }) }
    }
    case fulfilled(NEWSLETTER_SUBSCRIBE): {
      const { email } = action.meta

      return email
        ? { ...state, email, emailNotifications: true, emailOnUpdate: true }
        : { ...state, emailNotifications: true, emailOnUpdate: true }
    }
    default:
      return state
  }
}

export const setPreference = (key, value) => ({
  type: SET_PREFERENCE,
  payload: fetchJSON('/set_preference.json', { key, value }),
  meta: { key, value }
})

export const setUserPreference = (userId, key, value) => {
  if (userId) {
    return setPreference(key, value)
  } else {
    // This is for mocking our currentUser object when the current viewer is anonymous
    return {
      type: SET_PREFERENCE,
      meta: { key, value }
    }
  }
}

export const loadFriends = () => (dispatch, getState) => dispatch({
  type: LOAD_FRIENDS,
  payload: fetchJSON(`/users/${getState().currentUser.id}/friends.json`)
})

export const loadClubs = () => (dispatch, getState) => dispatch({
  type: LOAD_CLUBS,
  payload: fetchJSON(`/users/${getState().currentUser.id}/clubs.json`)
})

export const newsletterSubscribe = (email = null) => (dispatch, getState) => dispatch({
  type: NEWSLETTER_SUBSCRIBE,
  meta: { email },
  payload: fetchJSON(
    `/users/${getState().currentUser.id}.json`,
    { user: (email ? { email, email_notifications: true, email_on_update: true } : { email_notifications: true, email_on_update: true }) },
    { method: 'PATCH' }
  ).then(res => {
    if (res.success !== 1) { return Promise.reject(res) }
    return res
  })
})

export const clearTrialBanner = (id) => ({
  type: CLEAR_TRIAL_BANNER,
  payload: fetchJSON(`/users/${id}/clear_trial_banner.json`, {}, { method: 'POST' })
})
